import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'tab',
  templateUrl: './tab.component.html',
})
export class TabComponent {
  constructor() {
    console.log(this.template);
  }
  @Input('tabTitle') title: string = '';
  @Input() tooltip: string = '';
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() template: any;
  @Input() dataContext: any;
  @Input() hasApiError=false;
  @Input() apiErrorMessage:string='';
  @Input() isExternalAsset: boolean = false;
}
